import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'signedTemperature'
})
export class SignedTemperaturePipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const num = Number(value);
    if (isNaN(num)) {
      return '';
    }
    return (num > 0 ? '+' + num : '' + num);
  }
}
